<template>
    <div>
        <ModalHeader title="프리랜서 용역계약서 수정"  :close-action="goBack"/>
        <div style="flex:1; overflow:auto; padding:20px;" id="contract_print">
            <table>
                <colgroup>
                    <col style="width:60px;">
                    <col style="width:80px;">
                    <col style="">
                </colgroup>
                <tbody>
                <tr>
                    <td rowspan="3" class="tb_label">회사</td>
                    <td class="tb_label">상호명</td>
                    <td class="tb_content">(주)미누스토리</td>
                </tr>
                <tr>
                    <td class="tb_label">대표이사</td>
                    <td class="tb_content">서기성</td>
                </tr>
                <tr>
                    <td class="tb_label">주소</td>
                    <td class="tb_content">경기도 평택시 청북읍 고렴산단로 133.</td>
                </tr>
                <tr>
                    <td rowspan="3" class="tb_label">직원</td>
                    <td class="tb_label">성명</td>
                    <td class="tb_content">{{contract_info.name}}</td>
                </tr>
                <tr>
                    <td class="tb_label">생년월일</td>
                    <td class="tb_content">{{contract_info.jumin}}</td>
                </tr>
                <tr>
                    <td class="tb_label">연락처</td>
                    <td class="tb_content">{{contract_info.phone}}</td>
                </tr>
                <tr>
                    <td rowspan="3" class="tb_label"><div>입금</div><div style="margin-top:5px;">계좌</div></td>
                    <td class="tb_label">예금주</td>
                    <td class="tb_content">{{contract_info.name}}</td>
                </tr>
                <tr>
                    <td class="tb_label">은행</td>
                    <td class="tb_content">{{contract_info.bank_name}}</td>
                </tr>
                <tr>
                    <td class="tb_label">계좌번호</td>
                    <td class="tb_content">{{contract_info.bank_account}}</td>
                </tr>
                </tbody>
            </table>

            <div class="line_text" style="margin-top:30px;">제 1 조【근로계약의 효력】</div>
            <div class="line_text">① {{contract_info.work_date_str}} ~ {{contract_info.work_date_str}}까지 근로계약을 체결합니다. </div>

            <div class="line_text" style="" v-html="contract_text"></div>

            <div style="text-align:center; padding:30px 0px;">{{contract_info.work_date_str}}</div>

            <div style="display:flex;">
                <div style="flex:1;"></div>
                <div>
                    <div>사용자 :</div>
                    <div style="margin-top:10px;">직원 :</div>
                </div>
                <div>
                    <div style="text-align:right; position:relative;"> (주)미누스토리<img :src="require('@/assets/img/sign.jpg')" style="position:absolute; right:-30px; top:-10px; width:30px;"></div>
                    <div style="text-align:right; margin-top:10px;">{{contract_info.name}}</div>
                </div>
                <div style="width:30px;"></div>
            </div>

            <template v-if="false">
                <div class="line_text">본 계약은 잉용직 근로자의 고용, 안전 준수에 대한 내용을 포함하며, 아래와 같은 조건에 따라 체결됩니다.</div>
                <br>
                <div class="line_text" style="">1. 근로계약서</div>
                <div class="line_text">[근로자 정보]</div>
                <div class="line_text">&nbsp;1.이름: {{contract_info.name}}</div>
                <div class="line_text">&nbsp;2.주민등록번호(또는 생년월일): {{contract_info.jumin}}</div>
                <div class="line_text">&nbsp;3.연락처: {{contract_info.phone}}</div>
                <div class="line_text">&nbsp;4.임금지급 계좌번호: {{contract_info.bank_account}} ({{contract_info.bank_name}})</div>
                <br>
                <div class="line_text" style="white-space: pre-wrap;">{{contract_text}}</div>

                <div style="text-align:center; padding:24px 0px;">{{contract_info.work_date_str}}</div>

                <div class="line_text">근로자 이름: {{contract_info.name}}</div>
                <div class="line_text" >고용주 서명: 주식회사 미누스토리 대표이사 서기성</div>
            </template>

            <ProgressButton
                    buttonText="계약하기"
                   @click="agree"
                    style="margin-top:20px;"
            />

        </div>
    </div>
</template>

<script>
    import ModalHeader from "../common/ModalHeader";
    import ProgressButton from "../common/ProgressButton";
    export default {
        name: "Contract",
        components: {ProgressButton, ModalHeader},
        props : {
            work_calendar_idx : {
                type : [Number, String],
                default : -1
            },
            completeAction : {
                type : Function,
                default : () => {}
            }
        },
        data(){
            return {
                contract_text : '',
                contract_info : {}
            }
        },
        methods : {
            goBack(){
                this.$GlobalStore.closeLastModal();
            },
            async getContractInfo(){
                const parameters = {};
                parameters.work_calendar_idx = this.work_calendar_idx;

                const res = await this.$Axios.get('/api/work/contract', {params : parameters});
                this.contract_text = res.data.contract_text;
                this.contract_info = res.data.contract_info;
            },
            async agree(){
                /*eslint-disable no-undef */
                const scrollHeight = document.querySelector('#contract_print').scrollHeight;
                const canvas = await html2canvas(document.querySelector('#contract_print'), {
                    scale: 2,
                    height: scrollHeight,
                    windowHeight: scrollHeight,
                    scrollX: 0,
                    scrollY: 0,
                });
                const contract_image_str = canvas.toDataURL('image/png').replace('data:image/png;base64,', '');
                this.$GlobalStore.closeLastModal();
                this.completeAction(contract_image_str);
            }
        },
        created() {
            this.getContractInfo();
        }
    }
</script>
<style>
    .line_text p{line-height:24px;}
</style>
<style scoped>
    .line_text{line-height:24px;}
    table{ border-collapse: collapse;width:100%;}
    table td {border:1px solid #bfbfbf; padding:10px 10px;}
    .tb_label{text-align:center; font-weight:bold; background-color: #dae6f3;}
    .tb_content{line-height:18px;}
</style>